export default __webpack_public_path__ + "static/media/cynthia-del-rio.43673965.jpg";